// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoText_root__18D1e"};